export type ViewScope = {
  page: string;
  spaceId?: number;
  projectId?: number;
  organizationId?: number;
  entityId?: string | number;
  viewId?: string;
};

export const buildViewScopeKey = (scope: ViewScope): string =>
  [scope.page, scope.spaceId, scope.projectId, scope.organizationId, scope.entityId, scope.viewId]
    .filter((value) => value !== undefined && value !== null && value !== '')
    .join(':');
